export default __webpack_public_path__ + "static/plant_with_bottle-d7e0bc86915cf215996c67fa0d4442c2.png";